jQuery(document).ready(function() {	

// Custom JS functions
    
    //accordion 
    if($('.accordion')[0]) {
        $('.accordion-heading').click(function() {
            console.log('clicked');
            $('.accordion-content').slideUp();
            $(this).siblings('.accordion-content').slideDown();
        });
    }
    
    
    $('.hero-bkg-slider').slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 1000,
        fade: true,
        cssEase: 'linear',
        autoplay: true,
        pauseOnHover:false,
        pauseOnFocus:false,
        autoplaySpeed: 3500,
    }); 
    
    /*$('.specials-slick').slick({
        dots: false,
        infinite: true,
        speed: 1000,
        fade: true,
        cssEase: 'linear',
        autoplay: true,
        pauseOnHover:false,
        pauseOnFocus:false,
        autoplaySpeed: 3500,
        arrows: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        nextArrow: '<i class="fas fa-arrow-right"></i>',
        prevArrow: '<i class="fas fa-arrow-left"></i>',
    }); */
    
     $('.specials-slick').slick({
        dots: false,
        arrows: true,
        infinite: true,
        speed: 300,
        fade: false,
        cssEase: 'linear',
        autoplay: false,
        adaptiveHeight: true,
        autoplaySpeed: 2000,
        pauseOnHover:false,
        slidesToShow: 2,
        slidesToScroll: 1,
        nextArrow: '<i class="fas fa-arrow-right"></i>',
        prevArrow: '<i class="fas fa-arrow-left"></i>',
        responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        }],
    });
    
    function toggleDropdown (e) {
      let _d = $(e.target).closest('.dropdown'),
          _m = $('.dropdown-menu', _d);
      setTimeout(function(){
        let shouldOpen = e.type !== 'click' && _d.is(':hover');
        _m.toggleClass('show', shouldOpen);
        _d.toggleClass('show', shouldOpen);
        $('[data-toggle="dropdown"]', _d).attr('aria-expanded', shouldOpen);
      }, e.type === 'mouseleave' ? 50 : 0);
    }
    
    $(window).on('load resize', function() {
        var viewport_window = $(window).width();
    
        if(viewport_window > 991) {
            $('body')
              .on('mouseenter mouseleave','.dropdown',toggleDropdown)
              .on('click', '.dropdown-menu a', toggleDropdown);
        }
    });
});


// WEBPACK FOOTER //
// ./scripts/mta.js